const OurBussinessRouter = [
    {
      path: '/our-bussiness/banner-product',
      name: 'BannerProduct',
      layout: "dashboard",
      component: () => import('@/views/LandingPage/OurBussiness/BannerProduct.vue'),
      meta: {
        title: 'Quản lý banner product',
        openSidebarKey: 'ourBussiness',
      }
    },
    {
        path: '/our-bussiness/banner-service',
        name: 'BannerService',
        layout: "dashboard",
        component: () => import('@/views/LandingPage/OurBussiness/BannerService.vue'),
        meta: {
          title: 'Quản lý banner service',
          openSidebarKey: 'ourBussiness',
        }
    },
    {
        path: '/our-bussiness/packages',
        name: 'PackageManage',
        layout: "dashboard",
        component: () => import('@/views/LandingPage/OurBussiness/package/index.vue'),
        meta: {
          title: 'Quản lý package',
          openSidebarKey: 'ourBussiness',
        }
    },
    {
      path: '/our-bussiness/packages/add',
      name: 'AddPackage',
      layout: "dashboard",
      component: () => import('@/views/LandingPage/OurBussiness/package/Controller.vue'),
      meta: {
        title: 'Thêm mới package',
        openSidebarKey: 'ourBussiness',
      }
  },
  {
    path: '/our-bussiness/packages/:id',
    name: 'EditPackage',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/OurBussiness/package/Controller.vue'),
    meta: {
      title: 'Cập nhật package',
      openSidebarKey: 'ourBussiness',
    },
  },
  {
    path: '/our-bussiness/projects',
    name: 'ProjectManage',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/OurBussiness/project/index.vue'),
    meta: {
      title: 'Quản lý dự án',
      openSidebarKey: 'ourBussiness',
    }
  },
  {
    path: '/our-bussiness/projects/add',
    name: 'AddProject',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/OurBussiness/project/Controller.vue'),
    meta: {
      title: 'Thêm mới dự án',
      openSidebarKey: 'ourBussiness',
    }
  },
  {
    path: '/our-bussiness/projects/:id',
    name: 'EditProject',
    layout: "dashboard",
    component: () => import('@/views/LandingPage/OurBussiness/project/Controller.vue'),
    meta: {
      title: 'Cập nhật dự án',
      openSidebarKey: 'ourBussiness', 
    }
  }
]
  
export default OurBussinessRouter